import React,{useEffect} from "react";
import { Link } from "react-router-dom";
import "./Courses.css";

function CourseDetails() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);
  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-auto">
              <div className="breadcrumbs__content d-flex">
                <div className="breadcrumbs__item">
                  <Link to="/">Home</Link>
                </div>
                <div className="breadcrumbs__item">
                  <Link to="/courses">All Courses</Link>
                </div>
                <div className="breadcrumbs__item">
                  <Link>Course Details</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="relative">
        <section className="page-header bg-light-6">
          <div className="page-header__bg">
            <div
              className="bg-image js-lazy"
              data-bg="img/event-single/bg.png"
            ></div>
            <div className="container">
              <div className="page-header__content pt-90 pb-90">
                <div className="row y-gap-30">
                  <div className="col-xl-7 col-lg-8">
                    <div className="d-flex x-gap-15 y-gap-10 pb-20">
                      <div>
                        <div className="badge px-15 py-8 text-11 bg-green-1 text-dark-1 fw-400">
                          BEST SELLER
                        </div>
                      </div>
                      <div>
                        <div className="badge px-15 py-8 text-11 bg-orange-1 text-white fw-400">
                          NEW
                        </div>
                      </div>
                      <div>
                        <div className="badge px-15 py-8 text-11 bg-purple-1 text-white fw-400">
                          POPULAR
                        </div>
                      </div>
                    </div>
                    <div>
                      <h1 className="text-30 lh-14 pr-60 lg:pr-0">
                        Angular - The Complete Guide (2022 Edition)
                      </h1>
                    </div>
                    <p className="mt-20">
                      Use XD to get a job in UI Design, User Interface, User
                      Experience design, UX design & Web Design
                    </p>
                    <div className="d-flex x-gap-30 y-gap-10 items-center flex-wrap pt-20">
                      <div className="d-flex items-center">
                        <div className="text-14 lh-1 text-yellow-1 mr-10 mr-6">
                          4.5
                        </div>
                        <div className="d-flex x-gap-5 items-center">
                          <div className="icon-star text-11 text-yellow-1 mr-6">
                            <i class="ri-star-line"></i>
                          </div>
                          <div className="icon-star text-11 text-yellow-1 mr-6">
                            <i class="ri-star-line"></i>
                          </div>
                          <div className="icon-star text-11 text-yellow-1 mr-6">
                            <i class="ri-star-line"></i>
                          </div>
                          <div className="icon-star text-11 text-yellow-1 mr-6">
                            <i class="ri-star-line"></i>
                          </div>
                          <div className="icon-star text-11 text-yellow-1 mr-6">
                            <i class="ri-star-line"></i>
                          </div>
                          <div className="text-14 lh-1 text-light-1 ml-10">
                            (1991)
                          </div>
                        </div>
                        <div className="d-flex items-center text-light-1 ml-10">
                          <div className="icon icon-person-3 text-13">
                            <i class="ri-user-line"></i>
                          </div>
                          <div className="text-14 ml-8">
                            853 enrolled on this course
                          </div>
                        </div>
                        <div className="d-flex items-center text-light-1 ml-10">
                          <div className="icon icon-wall-clock text-13">
                            <i class="ri-time-line"></i>
                          </div>
                          <div className="text-14 ml-8">updated on 11/2024</div>
                        </div>
                        <div></div>
                      </div>
                    </div>
                    <div className="d-flex items-center pt-20">
                      <div
                        className="bg-image size-30 rounded-full js-lazy"
                        style={{
                          backgroundImage:
                            "url(https://educrat-react.vercel.app/assets/img/general/avatar-1.png)",
                        }}
                      ></div>
                      <div className="text-14 lh-1 ml-10">Albert Flores</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className="courses-single-info js-pin-content"
          style={{ height: "100%", right: "7%", paddingTop: "80px" }}
        >
          <div
            className="bg-white shadow-2 rounded-8 border-light py-10 px-10"
            style={{ position: "sticky", top: "100px" }}
          >
            <div className="relative">
              <img
                className="w-100"
                src="https://educrat-react.vercel.app/assets/img/coursesCards/6.png"
                alt="course"
              />
              <div className="absolute-full-center d-flex justify-center items-center">
                <div
                  className="d-flex justify-center items-center size-60 rounded-full bg-white js-gallery cursor"
                  data-gallery="gallery1"
                >
                  <div className="icon-play text-18">
                    <i class="ri-play-large-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="courses-single-info__content scroll-bar-1 pt-30 pb-20 px-20">
              <div className="d-flex justify-between items-center mb-30">
                <div className="text-24 lh-1 text-dark-1 fw-500">$129</div>
                <div className="lh-1 line-through">$249</div>
              </div>
              <button className="button -md -purple-1 text-white w-1/1">
                Add to Cart
              </button>
              <button className="button -md -outline-dark-1 text-dark-1 w-1/1 mt-2">
                Buy Now
              </button>
              <div className="text-14 lh-1 text-center mt-30">
                30 day money guarantee
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseDetails;
